import React from 'react';
import { ArrowRight, Shield } from 'lucide-react';
import { Link } from 'react-router-dom';
import { siteConfig } from '../../config/site';
import Button from '../ui/Button';

const CarriersPreview: React.FC = () => {
  const featuredCarriers = siteConfig.carriers;
  const scrollingCarriers = [...featuredCarriers, ...featuredCarriers];

  const handleCarriersClick = () => {
    window.scrollTo({ top: 0 });
  };

  return (
    <section className="py-16 sm:py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-slate-900 mb-3">
            28+ carriers. Your choice.
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            When one carrier says no, you've got 19 more to try.
          </p>
        </div>

        {/* Scrolling Logos */}
        <div className="mb-10 overflow-hidden py-6">
          <div className="flex animate-scroll-mobile space-x-8 sm:space-x-12">
            {scrollingCarriers.map((carrier, index) => (
              <div
                key={`${carrier}-${index}`}
                className="flex-shrink-0 text-center min-w-[100px] sm:min-w-[120px]"
              >
                <div 
                  className="w-20 h-20 sm:w-24 sm:h-24 flex items-center justify-center mx-auto overflow-hidden transition-transform duration-300 hover:scale-110"
                >
                  {carrier === "Aetna" && (
                    <img src="/insurance logos/aetna new png.png" alt="Aetna" className="w-full h-full object-contain" loading="lazy" />
                  )}
                  {carrier === "American Home Life" && (
                    <img src="/insurance logos/AHL NEW PNG.png" alt="American Home Life" className="w-full h-full object-contain" loading="lazy" />
                  )}
                  {carrier === "American Amicable" && (
                    <img src="/insurance logos/AA new png.png" alt="American Amicable" className="w-full h-full object-contain" loading="lazy" />
                  )}
                  {carrier === "Americo" && (
                    <img src="/insurance logos/americo new png.png" alt="Americo" className="w-full h-full object-contain" loading="lazy" />
                  )}
                  {carrier === "Corebridge (AIG)" && (
                    <img src="/insurance logos/corebridge new png.png" alt="Corebridge" className="w-full h-full object-contain" loading="lazy" />
                  )}
                  {carrier === "Transamerica" && (
                    <img src="/insurance logos/transamerica new png.png" alt="Transamerica" className="w-full h-full object-contain" loading="lazy" />
                  )}
                  {carrier === "Liberty Bankers" && (
                    <img src="/insurance logos/LIBERTYT BANKERS PNG.png" alt="Liberty Bankers" className="w-full h-full object-contain" loading="lazy" />
                  )}
                  {carrier === "Royal Neighbors" && (
                    <img src="/insurance logos/royal new png.png" alt="Royal Neighbors" className="w-full h-full object-contain" loading="lazy" />
                  )}
                  {carrier === "Foresters" && (
                    <img src="/insurance logos/5d1121ad829994b960189b24_logo-foresters.png" alt="Foresters" className="w-full h-full object-contain" loading="lazy" />
                  )}
                  {carrier === "Combined Insurance" && (
                    <img src="/insurance logos/combined new png.png" alt="Combined Insurance" className="w-full h-full object-contain" loading="lazy" />
                  )}
                  {carrier === "F&G" && (
                    <img src="/insurance logos/fg new png.png" alt="F&G" className="w-full h-full object-contain" loading="lazy" />
                  )}
                  {carrier === "Athene" && (
                    <img src="/insurance logos/athene new png.png" alt="Athene" className="w-full h-full object-contain" loading="lazy" />
                  )}
                  {carrier === "Allianz" && (
                    <img src="/insurance logos/ALLIANZ NEW PNG.png" alt="Allianz" className="w-full h-full object-contain" loading="lazy" />
                  )}
                  {carrier === "Mutual of Omaha" && (
                    <img src="/insurance logos/moo new png.png" alt="Mutual of Omaha" className="w-full h-full object-contain" loading="lazy" />
                  )}
                  {!["Aetna", "American Home Life", "American Amicable", "Americo", "Corebridge (AIG)", "Transamerica", "Liberty Bankers", "Royal Neighbors", "Foresters", "Combined Insurance", "F&G", "Athene", "Allianz", "Mutual of Omaha"].includes(carrier) && (
                    <Shield className="h-6 w-6 text-navy-600" />
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center">
          <Button
            variant="primary"
            as={Link}
            to="/carriers"
            onClick={handleCarriersClick}
            className="inline-flex items-center gap-2"
          >
            <span>See All Carriers</span>
            <ArrowRight className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CarriersPreview;
